import { render, staticRenderFns } from "./pfqd2.vue?vue&type=template&id=703f3755&scoped=true&"
import script from "./pfqd2.vue?vue&type=script&lang=js&"
export * from "./pfqd2.vue?vue&type=script&lang=js&"
import style0 from "./pfqd2.vue?vue&type=style&index=0&id=703f3755&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703f3755",
  null
  
)

export default component.exports